export default __webpack_public_path__ + "static/media/epigro_1.e7312cd4.png";